import React from "react";
import { Link } from "react-router-dom";
import { APP_URLS } from "../constants";
const TechDetail = (props) => {


    return (
        <div className="tab active-tab" id="service-brain">
            <div className="content">
                <div className="row clearfix">
                    <div className="content-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column">
                            <h2>{props.headerTitle}</h2>
                            <div className="text" style={{textAlign:'justify'}}>{props.desc}</div>
                            
                            <Link to={APP_URLS.PORTFOLIO} className="theme-btn btn-style-four">Portfolio</Link>
                        </div>
                    </div>

                    <div className="image-column col-lg-6 col-md-12 col-sm-12">
                        <div className="inner-column clearfix">
                            <div className="image image-one wow fadeInRight" data-wow-delay="300ms" data-wow-duration="1500ms">
                                <img src={'images/'+props.image} alt="" />
                            </div>
                            <div className="image image-two wow fadeInRight" data-wow-delay="0ms" data-wow-duration="1500ms">
                                <img src={'images/'+props.image1} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TechDetail